export default "__VITE_ASSET__f27adcf2__"